import { getTransformedPosition, getTransformedDirection } from "../../Scene/Manager/TransformUtils";

const SPACES = {
    MALOC: 'maloc',
    WORLD: 'world',
};

const throwIfMissing = (tooth, key, type) => {
    if (!exists(tooth, key, type)) {
        throw new Error(`Donnée manquante (${key})`);
    }
};

const exists = (tooth, key, type) => {
    if (type === 'point') return tooth.pointSpheres.hasOwnProperty(key);
    if (type === 'vector') return tooth.vectors.hasOwnProperty(key);
    return false;
};

const getPointMaloc = (tooth, key) => {
    const sphere = tooth.pointSpheres[key];
    return [sphere.position.x, sphere.position.y, sphere.position.z];
};

const getPointWorld = (tooth, key) => {
    const sphere = tooth.pointSpheres[key];
    if (key === 'centralPit') tooth.centralPit = sphere;
    if (key === 'baryCenter') tooth.baryCenter = sphere;
    return getTransformedPosition(sphere);
};

const getVectorMaloc = (tooth, key) => {
    const vectorProp = `vec${key.replace('vec', '')}`;
    const v = tooth[vectorProp];
    return v ? [v.x, v.y, v.z] : [0, 0, 0];
};

const getVectorWorld = (tooth, key) => {
    const arrow = tooth.vectors[key];
    return getTransformedDirection(arrow);
};

const getPoint = (tooth, key, space = SPACES.WORLD) => {
    throwIfMissing(tooth, key, 'point');
    return space === SPACES.MALOC ? getPointMaloc(tooth, key) : getPointWorld(tooth, key);
};

const getVector = (tooth, key, space = SPACES.WORLD) => {
    throwIfMissing(tooth, key, 'vector');
    return space === SPACES.MALOC ? getVectorMaloc(tooth, key) : getVectorWorld(tooth, key);
};

export const getIdTooth = (tooth) => tooth.refObj.name.split('_').pop();

export const pointExists = (tooth, key) => exists(tooth, key, 'point');
export const vectorExists = (tooth, key) => exists(tooth, key, 'vector');

export const getCentralPitMaloc = (tooth) => getPoint(tooth, 'centralPit', SPACES.MALOC);
export const getCentralPitActual = (tooth) => getPoint(tooth, 'centralPit', SPACES.WORLD);
export const getRotationRootMaloc = (tooth) => getPoint(tooth, 'rotationRoot', SPACES.MALOC);
export const getRotationRootActual = (tooth) => getPoint(tooth, 'rotationRoot', SPACES.WORLD);
export const getBaryCenterMaloc = (tooth) => getPoint(tooth, 'baryCenter', SPACES.MALOC);
export const getBaryCenterActual = (tooth) => getPoint(tooth, 'baryCenter', SPACES.WORLD);
export const getDistalPointActual = (tooth) => getPoint(tooth, 'distal', SPACES.WORLD);
export const getMesialPointActual = (tooth) => getPoint(tooth, 'mesial', SPACES.WORLD);
export const getPointRotation = (tooth) => tooth.pointSpheres['rotationRoot'];

export const getVecRidgeActual = (tooth) => getVector(tooth, 'vecRidge', SPACES.WORLD);
export const getVecRidgeMaloc = (tooth) => getVector(tooth, 'vecRidge', SPACES.MALOC);
export const getVecVestibularLingualActual = (tooth) => getVector(tooth, 'vecVestibularLingual', SPACES.WORLD);
export const getVecVestibularLingualMaloc = (tooth) => getVector(tooth, 'vecVestibularLingual', SPACES.MALOC);
export const getVecRootActual = (tooth) => getVector(tooth, 'vecRoot', SPACES.WORLD);
export const getVecRootMaloc = (tooth) => getVector(tooth, 'vecRoot', SPACES.MALOC);
export const getVecArchTemplateNormal = (tooth) => getVector(tooth, 'vecArchTemplateNormal', SPACES.MALOC);
export const getVecArchTemplateTangent = (tooth) => getVector(tooth, 'vecArchTemplateTangent', SPACES.MALOC);
export const getVecTangentToFacialMaloc = (tooth) => getVector(tooth, 'vecTangentToFacial', SPACES.MALOC);
export const getVecTangentToFacialActual = (tooth) => getVector(tooth, 'vecTangentToFacial', SPACES.WORLD);
